export default __webpack_public_path__ + "static/AzoSansMedium-4757a8f55740520c33d08b7f4dc3c3e5.woff2";